<template>
  <component :is="feesState" @on-change-state="handleChangeState"></component>
</template>

<script setup>
import { ref } from 'vue'
import DefaultState from '@/views/service-form/FeesStep/_defaultWrapper.vue'
import GatewayState from '@/views/service-form/FeesStep/_gateway.vue'
import CallbackState from '@/views/service-form/FeesStep/_callback.vue'

const states = {
  default: DefaultState,
  gateway: GatewayState,
  callback: CallbackState
}

const feesState = ref(states.default)

const handleChangeState = (state) => {
  feesState.value = states[state]
}
</script>

<style lang="scss" scoped></style>
